import { useEffect } from 'react';

const MARKER = 'data-structured-data';

/**
 * Injects one or more JSON-LD schema blocks into <head>.
 *
 * Pass `schemas` as an array of plain objects — one per Schema.org type.
 * Any previously-injected blocks (tagged with data-structured-data) are
 * removed on re-render so the head never accumulates duplicates.
 */
export default function StructuredData({ schemas }) {
  useEffect(() => {
    // Remove any existing blocks we previously injected
    document.head.querySelectorAll(`script[${MARKER}="true"]`).forEach((n) => n.remove());

    if (!Array.isArray(schemas) || schemas.length === 0) return undefined;

    const scripts = schemas.map((schema) => {
      const el = document.createElement('script');
      el.setAttribute('type', 'application/ld+json');
      el.setAttribute(MARKER, 'true');
      el.textContent = JSON.stringify(schema);
      document.head.appendChild(el);
      return el;
    });

    return () => {
      scripts.forEach((el) => el.remove());
    };
  }, [schemas]);

  return null;
}
